import React, { Component } from 'react';

import moment from 'moment';

export default class GoalsViewInfo extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        // Variables


        // Methods

    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {

        let gForm = this.props.identity;

        if (gForm === null || gForm === undefined) {
            return (
                <div className={this.props.className} style={this.props.style}>
                    <div className="gc-new-slide-container">
                        <div className={"gc-slide"} style={{ height: '35.5rem' }}>
                        </div>
                    </div>
                </div>
            );
        }

        let scope = gForm.userId != null ? 'User' : (gForm.locationId != null ? 'Location' : 'ClientAccount');

        let locationMapReverse = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
            let key = e.locationID;
            if (!r[key]) {
                r[key] = e.name;
            }
            return r;
        }, {});

        let userMapReverse = this.props.users.reduce((r, e) => {

            let key = e.userId;
            if (!r[key]) {
                r[key] = e.fullName;
            }

            return r;
        }, {});

        let kpiMapReverse = this.props.reportKPIs.reduce((r, e) => {

            let key = e.reportKpiId;
            if (!r[key]) {
                r[key] = { name: e.name, type: e.type };
            }

            return r;
        }, {});

        let monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        let activeKpiName = kpiMapReverse[gForm.reportKPIId] != undefined ? kpiMapReverse[gForm.reportKPIId].name : '';
        let activeKpiType = kpiMapReverse[gForm.reportKPIId] != undefined ? kpiMapReverse[gForm.reportKPIId].type : '';

        let fromYear = moment(gForm.fromDate).format("YYYY");
        let fromMonth = moment(gForm.fromDate).format("MM");
        let fromDay = moment(gForm.fromDate).format("DD");
        let toYear = moment(gForm.toDate).format("YYYY");
        let toMonth = moment(gForm.toDate).format("MM");
        let toDay = moment(gForm.toDate).format("DD");

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className="gc-new-slide-container full">
                    <div className={"gc-slide"} style={{ height: '35.5rem' }}>
                        <div className={"gc-review-header scope"}>
                            <div className={"gc-review-header-text"}>Scope</div>
                            <div className={"gc-review-underheader-alt"}>
                                {scope === 'ClientAccount' ? 'Company Wide' : (scope === 'Location' ? 'Location Wide' : (scope === 'User' ? 'Specific Employee' : ''))}
                            </div>
                        </div>

                        <div className={"gc-review-header target"}>
                            <div className={"gc-review-header-text"}>Target</div>
                            <div className={"gc-review-underheader-alt"}>{"Location: " + (gForm.locationId != null ? locationMapReverse[gForm.locationId] : 'N/A')}</div>
                            <div className={"gc-review-underheader-alt"}>{"Employee: " + (gForm.userId != null ? userMapReverse[gForm.userId] : 'N/A')}</div>
                        </div>
                        <div className={"gc-review-header identity"}>
                            <div className={"gc-review-header-text"}>Identity</div>
                            <div className={"gc-review-underheader-alt"}>{'Name: ' + gForm.name}</div>
                            <div className={"gc-review-underheader-alt"}>{'Description: ' + gForm.description}</div>
                        </div>
                        <div className={"gc-review-header details"}>
                            <div className={"gc-review-header-text"}>Details</div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    gForm.type === '#' ?
                                        "The goal is to get " + activeKpiName + (gForm.useUnder ? ' under ' : ' over ') + (activeKpiType === 'MNY' ? "$" : "") + gForm.value + (activeKpiType === 'PCT' ? "%" : "")
                                        :
                                        "The goal is to get " + activeKpiName + " " + gForm.value + "% " + (gForm.useUnder ? 'under' : 'over') + " last year"
                                }
                            </div>
                        </div>
                        <div className={"gc-review-header time"}>
                            <div className={"gc-review-header-text"}>Time</div>
                            <div className={"gc-review-underheader-alt"}>
                                {'The goal repeats every ' + (gForm.timeFrame != null ? gForm.timeFrame.toLowerCase() : '') + " beginning " +
                                    monthList[parseInt(fromMonth) - 1] + " " + fromDay + ", " + fromYear + " and ending " +
                                    monthList[parseInt(toMonth) - 1] + " " + toDay + ", " + toYear}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="gc-next-bar flat">

                </div>
            </div>
        );
    }
}